// extracted by mini-css-extract-plugin
export default {"section":"LineChart_section__ncGHE","title_wrapper":"LineChart_title_wrapper__Q3PiW","unit":"LineChart_unit__IHmEl","wrapper":"LineChart_wrapper__8zMQb"};